//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import productCategoryQuery from '~/apollo/queries/product/category-slug'
import productCategoriesQuery from '~/apollo/queries/product/all-categories'

export default {
  mixins: [seo],
  data () {
    return {
      fetched: false
    }
  },
  apollo: {
    productCategories: {
      prefetch: true,
      query: productCategoryQuery,
      variables () {
        return { slug: this.$route.params.slug }
      },
      result ({ data, loading, networkStatus }) {
        if (data.productCategories && data.productCategories.data && data.productCategories.data.length > 0) {
          this.seoTitle = data.productCategories.data[0].attributes.name
        }
        this.fetched = true
      },
      error (error) {
        console.log(error)
        this.fetched = true
      }
    },
    allProductCategories: {
      query: productCategoriesQuery,
      prefetch: true
    }
  },
  methods: {
    getColumnClass (smallTicketItem) {
      return smallTicketItem ? 'column is-one-quarter pt-0 pb-0' : 'column is-one-third pt-0 pb-0'
    },
    getTabletColumnClass (smallTicketItem) {
      return smallTicketItem ? 'column is-one-third pt-0 pb-0' : 'column is-half pt-0 pb-0'
    }
  },
  computed: {
    mixedTiles () {
      const ret = []
      const products = this.productCategories.data[0].attributes.products.data
      const showcases = this.productCategories.data[0].attributes.showcases.data
      for (let i = 0; i < products.length; i++) {
        showcases.forEach((showcase) => {
          if ((!showcase.attributes.indent && i === 0) || (showcase.attributes.indent === i)) {
            ret.push(showcase)
          }
        })
        ret.push(products[i])
      }
      showcases.forEach((showcase) => {
        if (showcase.attributes.indent >= products.length) {
          ret.push(showcase)
        }
      })
      return (ret.length > 0) ? ret : null
    }
  }
}

